import React, { Component } from 'react';
import { Tabs } from 'antd';
import _ from 'lodash';

const years = [];
for(let I = 2018; I <= new Date().getFullYear() + 1; I++) {
    years.push(I)
};

class TabsYears extends Component {
    renderTabs() {
        return _.map(years, y => <Tabs.TabPane tab={y.toString()} key={y.toString()}></Tabs.TabPane>)
    }
    render() { 
        return <div className={'tabs-years'} style={this.props.style}>
            <Tabs 
                tabBarGutter={0} 
                onChange={this.props.onChange} 
                defaultActiveKey={this.props.year}
            >
                {this.renderTabs()}
            </Tabs>
        </div>
    }
};

export default TabsYears;


// WEBPACK FOOTER //
// ./src/components/TabsYears.jsx